import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SeoGetAll } from '../../services';

export const fetchSeoGetAll = createAsyncThunk(
    'seoGetAll/fetchSeoGetAll',
    async () => {
        const response = await SeoGetAll()
        return response.result
    }
);

const seoGetAllSlice = createSlice({
    name: 'seoGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSeoGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSeoGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSeoGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default seoGetAllSlice.reducer;
